import { OfferPage } from '../../components';
import { withLayout } from '../../Layout/Layout';
import { httpGet } from '../../utils/httpClient';

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};
export const getStaticProps = async ({ params }) => {
  const offerPageRes = await httpGet(
    `${process.env.javaApiUrl}/offer/${params.id}`
  );
  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation/airlines/articles/${params.id}`
  );


  if (offerPageRes.status >= 400) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }
  const offerPage = await offerPageRes.json();
  const recommendation = await recommendationRes.json();
  let airlineReviewsRes;
  let airlineReviews;
  let otherAirlinesRes;
  let otherAirlines;
  if (offerPage?.airline?.code) {
    airlineReviewsRes = await httpGet(
      `${process.env.javaApiUrl}/airline/review?code=${offerPage.airline.code}`
    );
    otherAirlinesRes = await httpGet(
      `${process.env.javaApiUrl}/offer?page=0&size=200`
    );

    airlineReviews = await airlineReviewsRes.json();
    otherAirlines = await otherAirlinesRes.json();
    offerPage.airlineReviews = airlineReviews?.content;
    offerPage.otherAirlines = otherAirlines?.content.filter(offer => {
      return offer.airline.code && (offer.airline.code !== offerPage.airline.code)
    });

    offerPage.flightInfo = JSON.parse(offerPage.flightInfo);
    offerPage.airlineInfo = JSON.parse(offerPage.airlineInfo);
    offerPage.faq = JSON.parse(offerPage.faq);
  }

//   const redirectResult = contentRedirect(article, params.id, 'airlines', 'offers');
//   if (redirectResult) {
//     return redirectResult;
//   }
  return {
    props: {
      offerPage,
      recommendation
    },
    revalidate: 60,
  };
};

function FlightOffer({
  offerPage,
  recommendation,
  setLoginDialogState,
  authCompleted,
}) {
  return (
    <OfferPage
      article={offerPage}
      recommendation={recommendation}
      setLoginDialogState={setLoginDialogState}
      authCompleted={authCompleted}
    />
    // <Article
    //   article={offerPage}
    //   setLoginDialogState={setLoginDialogState}
    //   authCompleted={authCompleted}
    // />
  );
}

export default withLayout(FlightOffer, false);
